/** Iter 632 — customer wizard · Iter-621 pay-choice card (JSX moved verbatim from EngageSessionPanel.jsx). */
import React from "react";
import { CheckCircle2 } from "lucide-react";

export default function PayChoiceCard({ w }) {
  const { s, purchasedPts, setPayChoice } = w;
  return (
    <div className="text-center" data-testid="cust-pay-choice">
      <CheckCircle2 className="w-8 h-8 mx-auto text-emerald-500" />
      <div className="mt-2 font-display text-lg font-black text-slate-900">
        QR Code Scanned Successfully!
      </div>
      <p className="mt-1 text-sm text-slate-600">
        You have {purchasedPts} purchased/gifted points. How would you like to pay?
      </p>
      <button
        type="button"
        data-testid="cust-choice-review"
        onClick={() => setPayChoice("review")}
        style={{ backgroundColor: "#2563EB", color: "#ffffff" }}
        className="mt-4 w-full inline-flex items-center justify-center rounded-full font-bold py-3 text-sm shadow-card"
      >
        📸 Review for {Number(s.discount_percent || s.vendor?.discount_percent || 0).toFixed(0)}% off
      </button>
      <p className="mt-1.5 text-xs text-slate-500">
        Snap a photo &amp; share it — the store&apos;s full discount plus reward points.
      </p>
      <button
        type="button"
        data-testid="cust-choice-points"
        onClick={() => setPayChoice("points")}
        className="mt-3 w-full inline-flex items-center justify-center rounded-full border-2 border-amber-400 bg-amber-50 text-amber-800 font-bold py-3 text-sm"
      >
        ⭐ Just pay with my points — 5% off, no review
      </button>
      <p className="mt-1.5 text-xs text-slate-500">
        Skip the review entirely. Flat 5% off and your bought or gifted points can cover the
        whole bill — you only pay the small service fee on the card payment (earned points
        need the review path). No 48-hour follow-ups.
      </p>
    </div>
  );
}
